import { Component, OnInit, ViewChild } from '@angular/core';
import { data } from 'jquery';
import { FileUpload } from 'primeng/fileupload';
import { VoterSearchAPIService } from '../../services/api/api.service';
import { VOTER_SEARCH_API_CONSTANTS } from '../../constants/api.constant';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-voter-search-config',
  templateUrl: './voter-search-config.component.html',
  styleUrls: ['./voter-search-config.component.scss']
})
export class VoterSearchConfigComponent implements OnInit {
  editableMode: boolean = false;
  photoFlag: boolean = false;
  uploadedFiles = [];
  uploadAPI = VOTER_SEARCH_API_CONSTANTS.FILE_UPLOAD_VOTER_SEARCH_CONFIG;
  fileViewAPI = `${environment.API_BASE}${environment.FILE_VIEW_S3}`;

  @ViewChild("imageUpload1", { static: false }) imageUpload1: FileUpload;
  @ViewChild("imageUpload2", { static: false }) imageUpload2: FileUpload;
  @ViewChild("imageUpload3", { static: false }) imageUpload3: FileUpload;
  @ViewChild("imageUpload4", { static: false }) imageUpload4: FileUpload;
  @ViewChild("imageUpload5", { static: false }) imageUpload5: FileUpload;
  model:any = {}


  constructor(private service: VoterSearchAPIService,) {
    this.model ={
      "banner1":"",
      "banner2":"",
      "banner3":"",
      "banner4":"",
      "banner5":"",
      "text1":"text1",
      "text2":"text2",
      "text3":"text3",
      "text4":"text4"
    }
   }

  ngOnInit() {
    this.service.getVoterConfig().subscribe(d=>{
      this.model = d;
    });
  }

  saveImage1() {
    this.imageUpload1.upload();
  }
  saveImage2() {
    this.imageUpload2.upload();
  }
  saveImage3() {
    this.imageUpload3.upload();
  }
  saveImage4() {
    this.imageUpload4.upload();
  }
  saveImage5() {
    this.imageUpload5.upload();
  }

  saveUser() {
    console.log(this.model);
    this.service.updateVoterConfig(this.model).subscribe(d=>{
    
    })

  }

  
  onUploadSuccess1($event) { 
    this.model.banner1 = $event.originalEvent.body.files[0].filename;
  }
  onUploadSuccess2($event) { 
    this.model.banner2 = $event.originalEvent.body.files[0].filename;
  }
  onUploadSuccess3($event) { 
    this.model.banner3 = $event.originalEvent.body.files[0].filename;
  }
  onUploadSuccess4($event) { 
    this.model.banner4 = $event.originalEvent.body.files[0].filename;
  }
  onUploadSuccess5($event) { 
    this.model.banner5 = $event.originalEvent.body.files[0].filename;
  }
}
